export default __webpack_public_path__ + "static/media/pais-arg-mb.49266bf6.png";